const sizes = ['maxres', 'standard', 'high']

export function getInfo(snippet) {
  const thumbnails = snippet?.data?.thumbnails
  if (thumbnails) {
    for (let i in sizes) {
      const thumbnail = thumbnails[sizes[i]]
      if (thumbnail) {
        return {
          title: snippet.data.title,
          thumbnail: thumbnail.url,
        }
      }
    }
  }
  return null
}
